import { BRAND } from './brand';

/**
 * Build a clean wa.me URL that opens WhatsApp directly:
 *   - mobile: opens the WhatsApp app via URL scheme
 *   - desktop: opens web.whatsapp.com
 *
 * We strip everything but digits from the phone number and URL-encode
 * the message so umlauts, punctuation and spaces survive properly.
 *
 * Note: wa.me is the recommended universal short URL. We deliberately
 * avoid api.whatsapp.com which some corporate networks block.
 */
export function buildWhatsAppUrl(text) {
  const cleanPhone = (BRAND.whatsapp || '').replace(/[^0-9]/g, '');
  const message = text || 'Hallo UnfallHeld, ich brauche Unterstützung nach einem Unfall.';
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
}

/**
 * Programmatically open WhatsApp with maximum compatibility:
 *   - first try window.open(...) in a new tab (best UX, keeps the site open)
 *   - if the popup is blocked (returns null) -> same-tab navigation
 *
 * This avoids the "nothing happens" experience inside sandboxed iframes
 * (e.g. the Emergent preview) while still keeping the new-tab behaviour
 * on real devices.
 */
export function openWhatsApp(text) {
  const url = buildWhatsAppUrl(text);
  try {
    const popup = window.open(url, '_blank', 'noopener,noreferrer');
    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
}
